import {BaseOptions} from "../../../../dialog/options/base.options";

export class AddOrUpdateUserOptions extends BaseOptions {
  user?: any;
  userType?: string;
  showRole?: boolean;
  onInsertOrUpdateFinished = (user?: any) => {
  };
}
